import { render, staticRenderFns } from "./DialogPageSearch.vue?vue&type=template&id=652fb1ee"
import script from "./DialogPageSearch.vue?vue&type=script&lang=js"
export * from "./DialogPageSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports